module.exports = __webpack_public_path__ + "img/agua-sanitaria-duplo.634e5e46.png";